<script>
import {openImagePreview} from "@/composables/image-preview";

export default {
  name: "SeminarCard",
  props: ['item'],
  methods: {openImagePreview},
}
</script>

<template>
  <div class="seminarCard">
      <img
          v-if="item.img_url"
          class="seminarCard__previewable"
          alt=""
          :src="item.img_url"
          @click="openImagePreview(item.img_url)"
      >
      <img v-else alt="" :src="require(`@/assets/img/seminar-list/placeholder.png`)">
      <slot name="default"></slot>
      <div v-if="item.seminar_date">{{item.seminar_date}}</div>
  </div>

</template>

<style scoped lang="scss">
.seminarCard {
  border-radius: var(--cd-card-border-radius);
  background-color: var(--cd-card-bg);
  display: flex;
  flex-direction: column;
  justify-items: left;
  gap: 10px;
  padding: 10px;
  &__image {
    border-radius: var(--cd-card-border-radius);
  }
  &__previewable {
    cursor: zoom-in;
  }
}
</style>
